import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	type DialogProps,
	DialogTitle,
	Divider,
	Stack,
} from "@mui/material";
import type { ReactElement } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	handleResult: (result: boolean) => void;
	modalTitle?: string | ReactElement;
	modalContent?: string | ReactElement;
	confirmButtonText?: string;
	cancelButtonText?: string;
	startAdorment?: ReactElement;
	endAdornment?: ReactElement;
	divider?: boolean;
	hideConfirmButton?: boolean;
	hideCancelButton?: boolean;
	width?: string;
	padding?: string;
} & DialogProps;

export const MyPlannDialog: React.FunctionComponent<Props> = (props) => {
	const { t } = useResource();
	const {
		modalContent,
		modalTitle,
		confirmButtonText,
		handleResult,
		startAdorment,
		endAdornment,
		divider,
		hideConfirmButton,
		hideCancelButton,
		cancelButtonText,
		width,
		padding,
		...rest
	} = props;

	return (
		<Dialog onClose={() => handleResult(false)} {...rest}>
			<Stack direction="row" alignItems="center">
				{modalTitle && (
					<Stack width="100%">
						<DialogTitle variant="h2" width="100%">
							<Stack
								direction="row"
								alignItems="center"
								justifyContent="space-between"
								flexGrow={1}
							>
								<Stack direction="row" alignItems="center" gap={1}>
									{startAdorment}
									{modalTitle}
								</Stack>
								{endAdornment}
							</Stack>
						</DialogTitle>
						{divider && <Divider sx={{ mx: 1.6 }} />}
					</Stack>
				)}
			</Stack>

			{modalContent && (
				<DialogContent sx={{ padding, width }}>{modalContent}</DialogContent>
			)}

			<DialogActions>
				<Stack gap={1.2} width="100%">
					{!hideConfirmButton && (
						<Stack pt={1}>
							<Button
								color="primary"
								onClick={() => handleResult(true)}
								fullWidth
								variant="contained"
							>
								{confirmButtonText ?? t(Resources.Common.Confirm)}
							</Button>
						</Stack>
					)}
					{!hideCancelButton && (
						<Button
							onClick={() => handleResult(false)}
							fullWidth
							variant="text"
						>
							{cancelButtonText ?? t(Resources.Common.Cancel)}
						</Button>
					)}
				</Stack>
			</DialogActions>
		</Dialog>
	);
};
